import React, { memo, useMemo } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './FundManagerMenu.css';
import { useNavigate } from 'react-router-dom';

const FundManagermenu = () => {
  const navigate = useNavigate();

  const items = useMemo<MenuItem[]>(
    () => {
      const createMenuItem = (
        label: string,
        icon: string,
        path?: string,
        children?: MenuItem[]
      ): MenuItem => ({
        label,
        icon,
        command: path ? () => navigate(path) : undefined,
        items: children,
        template: (item, options) => (
          <a {...options} data-testid={`menu-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            <span className={item.icon}></span>
            <span className="ml-2">{item.label}</span>
          </a>
        )
      });

      return [
        createMenuItem('Dashboard', 'pi pi-fw pi-palette', '/fdashboard'),
        createMenuItem('Donations', 'pi pi-heart-fill', '/fundslist'),
        createMenuItem('Documents', 'pi pi-file', '/document'),
        createMenuItem('Organizations', 'pi pi-fw pi-building', '/orgapplications'),
        createMenuItem('Feedback', 'pi pi-envelope', '/ffeedback'),
        createMenuItem('Reports', 'nav-icon fas fa-copy', undefined, [
          createMenuItem('Donor Reports', 'pi pi-user', '/donorreports'),
          createMenuItem('Organization Reports', 'pi pi-sitemap', '/forgreports')
        ])
      ];
    },
    [navigate]
  );

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="font-bold border-round flex align-items-center justify-content-center">
          <PanelMenu model={items} />
        </div>
      </div>
    </aside>
  );
};

export default memo(FundManagermenu);
